/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Aicost_4_KInputs */

const en_mk_aicost_4_k = /** @type {(inputs: Mk_Aicost_4_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Included in the Team plan`)
};

const id_mk_aicost_4_k = /** @type {(inputs: Mk_Aicost_4_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termasuk dalam paket Tim`)
};

/**
* | output |
* | --- |
* | "Included in the Team plan" |
*
* @param {Mk_Aicost_4_KInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_aicost_4_k = /** @type {((inputs?: Mk_Aicost_4_KInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Aicost_4_KInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_aicost_4_k(inputs)
	return en_mk_aicost_4_k(inputs)
});